
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import vietnami from "../../assets/vietnami.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarVietnami({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar vietnámi fordító</title>
                <meta name='description' content="Ingyenes magyar vietnámi fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar vietnámi fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-vietnami-fordito" />
            </Helmet>
            <h1>Magyar vietnámi fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>


                <div className="sectionhead">
                    <h2>A magyar és vietnámi nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={vietnami} alt="vietnámi zászló"></img>
                </div>


                <p> Íme néhány alapvető különbség a vietnámi és a magyar nyelv között:</p>

                <h3>Hangrendszer</h3>

                <p>A vietnámi nyelvben sokkal több hang található, mint a magyarban. A vietnámi nyelvben vannak tonális jellemzők, vagyis a hangmagasság változása a szó jelentését is befolyásolhatja. A magyar nyelvben nem tonális.</p>

                <h3>Írásrendszer</h3>

                <p>A vietnámi nyelv egy latin betűs írásrendszert használ, de az írásmód eltér a magyarétól. A vietnámi írásmódben a diakritikus jelek és a több betűs kombinációk jelentéseket hordoznak.</p>

                <h3>Nyelvtani szerkezet</h3>

                <p>A vietnámi nyelv egy agglutináló jellegű nyelv, ami azt jelenti, hogy a szavakat és a mondatokat jelentéssel és nyelvtani információkkal kifejező ragokkal és kiegészítő elemekkel bővítik. A magyar nyelvben is találhatók agglutináló jellegű elemek, de más nyelvtani jellemzők dominálnak.</p>

                <h3>Szórend</h3>

                <p>A vietnámi nyelvben a szórend általában SVO (alany-ige-állítmány-tárgy), míg a magyar nyelvben a szabad szórend jellemző, vagyis a mondat elemei a kontextustól és a hangsúlytól függően változhatnak.</p>

                <h3>Szókincs</h3>

                <p>A vietnámi és a magyar nyelv szókincse is nagyon különböző. A két nyelv nem oszt közös szókincset, mivel eltérő nyelvi eredetűek és kultúrákból származnak.</p>

                <div className="sectionbottom">
                    <Link to="/vietnami-magyar-fordito">Vietnámi magyar fordító</Link>
                    <img src={vietnami} alt="Vietnámi zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
            </section>
        </>

    )
}

export default MagyarVietnami;